/** admin/sessions — KEYS. Covers worlds + sessions + the selector lists. */
export const adminSessionsKeys = {
  all: () => ['admin', 'sessions'] as const,
  /** All world-session lists (prefix). */
  sessionsAll: () => [...adminSessionsKeys.all(), 'by-world'] as const,
  sessions: (gameName: string, worldName: string) =>
    [...adminSessionsKeys.all(), 'by-world', gameName, worldName] as const,
  /** All world lists (prefix). */
  worldsAll: () => [...adminSessionsKeys.all(), 'worlds'] as const,
  worlds: (page: number, limit: number) => [...adminSessionsKeys.all(), 'worlds', page, limit] as const,
  games: () => [...adminSessionsKeys.all(), 'games'] as const,
  localSaves: () => [...adminSessionsKeys.all(), 'local-saves'] as const,
  scripts: () => [...adminSessionsKeys.all(), 'scripts'] as const,
  /** A world's running sessions checked against the matches the game server runs. */
  interruption: (gameName: string, worldName: string) =>
    [...adminSessionsKeys.all(), 'interruption', gameName, worldName] as const,
};
